import { SetStateAction } from 'react';

import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';

import { CalendarWrapper as Calendar } from '@/components/common/calendar-wrapper';

import { useFertilizationContext } from './useFertilizationContext';

import './Fertilization.css';

type Props = {
  className?: string;
  container?: HTMLElement;
};
export const FertilizationQCPanel = ({ className, container }: Props) => {
  const {
    fertPlateLotNo,
    setFertPlateLotNo,
    serum,
    setSerum,
    SOFMediaLotNo,
    setSOFMediaLotNo,
    fertMediaLotNo,
    setFertMediaLotNo,
    QCIsolate,
    setQCIsolate,
    culturePlateLotNo,
    setCulturePlateLotNo,
    mineralOilLot,
    setMineralOilLot,
    EHMMedia,
    setEHMMedia,
    cultureIncubatorNo,
    setCultureIncubatorNo,
    incubators,
  } = useFertilizationContext();

  return (
    <>
      <div className={className}>
        <div className="grid-container">
          <div className="grid-item">
            <label>QC Fert Plate (Lot#)*:</label>
            <InputText
              id="fertPlateLotNo"
              className="form-control"
              value={fertPlateLotNo}
              onChange={(e) => setFertPlateLotNo(e.target.value)}
            />
          </div>
          <div className="grid-item">
            <label>QC Serum (Expiration Date):</label>
            <InputText
              id="Serum"
              className="form-control"
              value={serum}
              onChange={(e) => setSerum(e.target.value)}
            />
          </div>
          <div className="grid-item">
            <label>QC IVC (Expiration Date)*:</label>
            <Calendar
              container={container}
              id="SOFMediaLotNo"
              className="form-control datepicker"
              value={SOFMediaLotNo}
              onChange={(e) =>
                setSOFMediaLotNo(
                  e.target.value as SetStateAction<Date | undefined>,
                )
              }
            />
          </div>
          <div className="grid-item">
            <label>QC Fert Media (Expiration Date)*:</label>
            <Calendar
              container={container}
              id="fertMediaLotNo"
              className="form-control"
              value={fertMediaLotNo}
              onChange={(e) =>
                setFertMediaLotNo(
                  e.target.value as SetStateAction<Date | undefined>,
                )
              }
            />
          </div>
          <div className="grid-item">
            <label>QC Isolate/SS+ (Expiration Date)*:</label>
            <InputText
              id="QCIsolate"
              className="form-control"
              value={QCIsolate}
              onChange={(e) => setQCIsolate(e.target.value)}
            />
          </div>
          <div className="grid-item">
            <label>QC Culture Plates (Lot#)*:</label>
            <InputText
              id="culturePlateLotNo"
              className="form-control"
              value={culturePlateLotNo}
              onChange={(e) => setCulturePlateLotNo(e.target.value)}
            />
          </div>
          <div className="grid-item">
            <label>QC Mineral Oil (Lot#)*:</label>
            <InputText
              id="mineralOilLot"
              className="form-control"
              value={mineralOilLot}
              onChange={(e) => setMineralOilLot(e.target.value)}
            />
          </div>
          <div className="grid-item">
            <label>QC EHM (Expiration Date)*:</label>
            <Calendar
              container={container}
              id="EHMMedia"
              className="form-control"
              value={EHMMedia}
              onChange={(e) =>
                setEHMMedia(e.target.value as SetStateAction<Date | undefined>)
              }
            />
          </div>
          <div className="grid-item">
            <label>Culture Incubator:</label>
            <Dropdown
              id="cultureIncubatorNo"
              className="form-control"
              options={incubators}
              optionLabel="name"
              optionValue="id"
              filter
              value={cultureIncubatorNo}
              onChange={(e) => setCultureIncubatorNo(e.target.value)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
